import { render, staticRenderFns } from "./EditReceiptComponent.vue?vue&type=template&id=a2bc740c"
import script from "./EditReceiptComponent.vue?vue&type=script&lang=js"
export * from "./EditReceiptComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports